import { render } from "./PdfCartaPropostaComComponentes.vue?vue&type=template&id=2632a4a2&scoped=true"
import script from "./PdfCartaPropostaComComponentes.vue?vue&type=script&lang=js"
export * from "./PdfCartaPropostaComComponentes.vue?vue&type=script&lang=js"

import "./PdfCartaPropostaComComponentes.vue?vue&type=style&index=0&id=2632a4a2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2632a4a2"]])

export default __exports__